// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#303133","menuActiveText":"#3860E2","subMenuActiveText":"#3860E2","menuBg":"#ffffff","menuHover":"#ECF2FF","subMenuBg":"#ffffff","subMenuHover":"#ECF2FF","sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = +qiL
// module chunks = 83